export default {
  aidc: {
    data: require('@/assets/images/aidc/02.gif'),
    data2: require('@/assets/images/aidc/his_en.gif'),
    data3: require('@/assets/images/aidc/reset_en.gif'),
    data4: require('@/assets/images/aidc/ability_en.gif'),
    data5: require('@/assets/images/aidc/primes_en.gif'),
    data6: require('@/assets/images/aidc/desi_en.gif'),

    context: {
      title: `Full-Stack Technology Provider for AI Infrastructure – Full-Stack AIDC Solutions`,
      introduction: 'Business Overview:',
      introduction_text: `A leading full-stack technology provider of AI computing infrastructure across Asia-Pacific, delivering integrated AIDC delivery & operation services as well as full-stack computing cluster services for clients.`,
      operations: '01 Integrated AIDC Delivery & Operations',
      operations_text0: ` We provide full-lifecycle operational services covering planning & design, construction delivery and operations management, and deliver integrated AIDC delivery & operations solutions for customers.`,
      operations_text1: `Business Footprint: Completed building area reaches approximately 1 million square meters, with over 500 MW of commissioned IDC capacity.
Project Locations: Domestic (Shanghai, Shenzhen Guangdong, Wuhu Anhui) and Overseas (Osaka Japan, Johor Malaysia, Bangkok Thailand, etc.).
By 2030, the planned total delivered building area will exceed 1.5 million square meters, with a planned total capacity of over 1.5 GW.`,
      case: 'Delivery Cases',
      projectCase: {
        shanghai: 'Shanghai',
        sz: 'Shenzhen',
        wuhu: 'Wuhu, Anhui',
        shanghaiDesc: [
          'Building scale: 8 data centers',
          'Total IT output: 300+MW',
          'Equipped with 3*200MVA 220kV municipal power supply',
        ],
        szDesc: [
          'Building scale: 3 buildings, 12,000 cabinets',
          'Total IT output: 90+ MW',
          'Equipped with 3*200MVA 220kV municipal power supply',
        ],
        wuhuDesc: [
          'Land scale: Total construction area 410,000 m²',
          'Buildings: 1×220kV substation, admin building, 8 data center buildings',
          'Total IT output: 300+ MW',
        ],
      },
      Maintenance: '02 Computing Cluster Deployment and O&M',
      Maintenance_text0: ` We provide full-lifecycle solutions covering planning & design, computing deployment delivery and intelligent O&M.`,
      Maintenance_text1: ` Business Footprint: Our projects span Southeast Asia, with extensive private deployment cases in Japan and North America. We have delivered and supported computing power exceeding 400,000 PFlops, operated a total load of over 300 MW, and completed deployment of more than 10 ten-thousand-GPU clusters.`,

      server: `AIDC Technical Service Capabilities`,
      server_text: ` We possess two core technical capabilities: integrated AIDC engineering construction and prefabricated modular delivery & operations. We have built a full-link technical system covering planning and design, engineering construction, modular prefabrication, on-site delivery and intelligent operations & maintenance.`,

      AIDCSolutions:
        'Full-Stack Solutions & Resource Assurance & High Energy Efficiency & High Reliability',
      AIDCSolutions_text: `1.Customized full-stack solutions for hyperscale AIDC covering planning & design, construction delivery and operations. 
2.Supported by experienced engineering teams and comprehensive technical services, we ensure efficient construction and delivery of projects with robust resource assurance.
3.Adopts advanced energy-saving architecture with PUE＜1.25. Delivers 24/7 rapid response and guarantees service availability with SLA＞99.99%.`,

      Delivery: `Industrial-Grade Collaborative Design 、In-House Prefabricated Manufacturing 、Rapid Deployment & Delivery`,
      Delivery_text: `1. Integrated design of AIDC modules based on industrial-grade platforms including BIM and SolidWorks.
2. Efficient prefabrication of standardized modules via automated production lines in smart factories.
3. Parallel execution of module prefabrication and on-site construction, cutting the traditional delivery cycle by over 40%.`,
    },
  },

  data_card: {
    title: `Custom‑Built AIDC Data Centers, Leading Enterprise in Digital New Infrastructure`,
    title_sub:
      'We provide industry-leading data centers and AI Data Centers (AIDC) to fuel rapid business growth for enterprises.',
    city: {
      name: 'City',
      text: `Build large‑scale data center industrial clusters in regions including the Beijing‑Tianjin‑Hebei, Yangtze River Delta and Guangdong‑Hong Kong‑Macao Greater Bay Area.`,
    },
    datacetre: {
      name: 'Data center',
      text: `Continuously expanding data center resources to deliver internet infrastructure services that empower enterprise innovation and development.`,
    },
    memory: {
      name: 'Port Capacity',
      text: `Establish high‑speed network connections with telecom operators, internet content providers and cloud service providers.`,
    },
    capacity: {
      name: 'Campus‑scale Capacity',
      text: `Deliver reliable IDC services and scalable high-power computing deployment to drive high-quality enterprise business growth.`,
    },
    cabinet: {
      name: 'Urban‑site Racks',
      text: `A robust, large-scale, and fully connected digital core infrastructure.`,
    },
  },

  data_card2: {
    title: `Specializing in the construction of AI data centers, substations, grid connection, battery energy storage systems (BESS) and new energy‑related infrastructure.`,
    title_sub: `Focusing on new‑energy infrastructure construction, we realize the integrated coordination of source‑grid‑load‑storage, and deliver holistic green‑infrastructure solutions with high reliability and low cost for supercomputing and data‑center projects.`,
    city: {
      name: 'Battery Energy Storage System',
      text: `One‑click full‑station configuration, one‑click delivery and inspection. Complete GWh‑scale power station configuration within 30 minutes, greatly shortening project deployment cycles, reducing manual configuration errors, and enabling rapid commissioning of energy‑storage power stations.`,
    },
    datacetre: {
      name: 'Power Transformer',
      text: `Stable and reliable power supply with low loss and high energy efficiency. It ensures continuous power supply for substations, data centers and energy storage stations, improving overall system stability and energy-saving performance.`,
    },
    memory: {
      name: 'Energy Storage Power Station',
      text: `Energy‑storage power stations enable peak‑load shifting and valley filling, smooth the output fluctuations of new‑energy power generation, and feature fast frequency and voltage regulation capabilities.`,
    },
    capacity: {
      name: 'Charging Equipment',
      text: `Efficient and energy‑saving, with intelligent operation and maintenance management. It supports cloud‑based monitoring, billing & settlement, and fault alarms, facilitating large‑scale networking and operation.`,
    },
  },

  bess_info: {
    title: `Energy Storage`,
    text: `The BESS (Battery Energy Storage System) delivers peak‑valley shifting and arbitrage, and effectively smooths output fluctuations of new‑energy sources such as photovoltaic and wind power. It enables fast frequency and voltage regulation and acts as emergency backup power under fault conditions, ensuring continuous power supply for AI data centers, substations and new‑energy stations. Adopting a modular design, it supports flexible capacity expansion and adapts to GWh‑scale large‑scale energy‑storage power stations. Equipped with full‑station one‑click configuration, it completes station setup within 30 minutes and simplifies delivery and inspection workflows. Interoperating with transformers, grid‑connection facilities and charging piles, it promotes the collaborative operation of source‑grid‑load‑storage integration, enhances grid stability, cuts comprehensive power‑consumption and O&M costs of stations, and facilitates the efficient implementation of green new‑energy infrastructure projects.`,

    title_sub01: {
      title: `Smart & High‑yield`,
      text_01: `12.5 MW / 50 MWh block‑based design, delivering 30% land‑area saving for GWh‑scale power stations.`,
      text_02: `Whole‑system top‑mounted heat dissipation, full liquid‑cooled AI intelligent temperature control, 14.5 % reduction in auxiliary power consumption, Powerbidder`,
      text_03: `Auxiliary power trading to boost station revenue; full‑liquid‑cooled SiC PCS with maximum efficiency of 99.3%.`,
      text_04: `Precise cluster‑level management, boosting system power generation by 8%.`,
    },
    title_sub02: {
      title: `Intelligent Operation and Maintenance`,
      text_01: `One‑click full‑station configuration, one‑click delivery and inspection. Complete GWh‑scale station configuration within 30 minutes.`,
      text_02: `Intelligent device ontology, supporting over 30 types of active early‑warnings, with fault root‑cause analysis and positioning accuracy ≥ 99%.`,
      text_03: `Automatic SOC balancing, no manual calibration required.`,
    },

    title_sub03: {
      title: `Safety and Reliability`,
      text_01: `Cell thermal‑electric zoning, preventing thermal runaway propagation; liquid‑electric isolated PCS for safer operation.`,
      text_02: `Multi‑layer full‑chain electrical protection, AI‑based arc detection with zero false alarms.`,
      text_03: `AI‑driven cell health diagnosis, thermal runaway warning accuracy ≥ 99%.`,
    },

    title_sub04: {
      title: `Grid‑friendly`,
      text_01: `90 ms station‑level response to support fast frequency and voltage regulation.`,
      text_02: `Wide grid strength adaptability for SCR1‑40, harmonic distortion ＜ 1%.`,
      text_03: `Equipped with grid‑forming functions including HV/LV ride‑through, inertia support, microsecond‑level voltage construction and black‑start capability.`,
    },
    typelist: {
      text0: {
        title: ' DC‑side Parameters',
        title1: 'Cell Type',
        title2: 'System Configuration',
        title3: 'Battery Capacity',
        title4: 'Battery Voltage Range',
      },
      text01: {
        title: 'Transformer Parameters',
        title1: 'Transformer Type',
        title2: 'Rated Capacity',
        title3: 'Voltage Ratio',
        title4: 'Vector Group',
        text: 'Dry‑type Transformer / Oil‑immersed Transformer',
      },
    },
  },
  transformer: {
    name: `Dry‑type Transformer/Oil‑immersed Transformer`,
    title: 'Dry‑type Transformer',
    title1: 'Oil‑immersed Transformer',
    text: `Transformer: Main application fields: power plants, power stations, industrial and mining enterprises, and user distribution substations.
The cast‑resin dry‑type transformer delivers outstanding safety performance with no risk of oil leakage or fire, suitable for indoor installation inside energy‑storage containers. Featuring a compact structure, the equipment effectively saves floor space and meets land‑planning requirements for overseas projects. It is simple for operation and maintenance with minimal routine workload, and maintains high operational stability under complex working conditions such as humidity and heavy dust. Fully CE‑certified, it complies with European electrical standards and possesses favorable overload capacity to accommodate load fluctuations resulting from frequent charging and discharging of energy‑storage systems. Adopting mature and reliable technology, it supports the project’s 37 kV/0.69 kV voltage ratio and Dy11 vector‑group configuration, ensuring long‑term stable and reliable operation of the energy‑storage system.`,
    dry: {
      info: [
        'Fire‑safe, no oil‑leakage risk',
        'Suitable for indoor & container installation, compact footprint',
        'Low maintenance requirement',
        'Good resistance to humidity and dust, strong environmental adaptability',
        'CE certified, compliant with European project standards',
        'Excellent overload capability',
      ],
    },
    oil: {
      info: [
        'Lower unit cost',
        'Suitable for large‑capacity outdoor application',
        'Superior heat dissipation performance',
      ],
    },
  },

  chargingEquipment: {
    name: `  Charging Equipment`,
    title: 'Split‑type charging pile / Integrated charging pile',

    text: `Charging equipment is widely applied in new‑energy stations, AI data‑center parks, industrial & commercial zones, shopping complexes and transport hubs. It supports charging for corporate fleets, logistics vehicles and private cars. Cooperated with energy storage, transformers and grid access systems, it realizes integrated source‑grid‑load‑storage dispatch to mitigate grid peak‑load impact. Supporting large‑scale networking deployment with multi‑power‑rate charging modes, it serves both domestic and overseas projects for self‑use and commercial billing operations, facilitating green infrastructure construction.`,
    dry: {
      info: [
        'Lightning‑fast charging, always online',
        'Peak efficiency up to 97.2%, maximum dual‑gun current 2400A',
        'Full‑matrix intelligent dynamic power allocation for maximum power utilization',
        'Supports aluminum cable access to reduce station‑construction costs',
      ],
    },
    title1: 'AC EV Charger',
    oil: {
      info: [
        'Managed charging with intelligent power regulation',
        'Safety & Reliability: IP65 protection rating and UV‑resistant design, adaptable to various harsh environments',
        'Durability & Energy‑saving: Extra‑long service life, standby power consumption as low as 5W',
      ],
    },
  },

  powerStation: {
    name: `Energy‑storage power station`,
    title:
      'As a vital component of the new‑type power system, energy‑storage power stations possess remarkable advantages in multiple aspects.',

    text: `The high‑efficiency power station adopts green‑low‑carbon concept and intelligent control system to maximize power‑generation efficiency. Suitable for photovoltaic and wind power scenarios, it reduces energy loss. Equipped with transformers and grid‑connection units, it supplies stable power for data centers and energy‑storage stations. Supported by intelligent monitoring platform, it realizes automatic condition adjustment and early warning. Cooperating with energy storage and charging facilities, it builds integrated source‑grid‑load‑storage system to stabilize power output. With high‑level protection for harsh outdoor environments, it supports large‑scale implementation of new‑type power infrastructure.`,
    dry: {
      info: [
        'First, peak‑shaving and valley‑filling to enhance grid stability.',
        'Second, improve the utilization efficiency of renewable energy.',
        'Third, fast response speed and high flexibility.',
        'Fourth, outstanding economic benefits.',
      ],
    },
    title1: 'Empowered by Green & Energy‑saving',
    oil: {
      info: [
        'Green & Energy‑saving · High‑efficiency Power Generation',
        'Green Empowerment for Energy Saving & Efficiency Improvement',
        'Energy‑saving & Low‑carbon, Smart Power Generation',
      ],
    },
  },
};
